module.exports = __webpack_public_path__ + "static/media/10_Sample_House.4ed18c4c.jpg";